import { Avatar as RawAvatar, styled } from '@arpeggi/ui'
import InfiniteScroll from 'react-infinite-scroll-component'

const Root = styled('div')

const Header = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: '32px'
})

const Body = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: '24px'
})

const Link = styled('a', {
  display: 'block',
  flexBasis: '80px',
  flexShrink: 0,
  width: '80px',
  transition: 'all 100ms ease',
  variants: {
    noOverflow: {
      true: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }
    }
  },
  '&:hover': {
    opacity: 0.8,
    transform: 'translateY(-2px)'
  }
})

const Avatar = styled(RawAvatar, {
  width: '100%',
  maxWidth: '80px',
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.1)',
  marginBottom: '12px'
})

const Title = styled('div', {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  fontSize: '$14',
  lineHeight: '20px',
  fontWeight: 500,
  variants: {
    success: {
      true: {
        color: '$indigo0700'
      }
    },
    big: {
      true: {
        fontSize: '$16'
      }
    }
  }
})

const StyledInfiniteScroll = styled(InfiniteScroll, {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '24px',
  justifyContent: 'center'
})

export const Collaborators = {
  Root,
  Header,
  Body,
  Link,
  Avatar,
  Title,
  InfiniteScroll: StyledInfiniteScroll
}
